export const LOGIN = '/login';
export const FORGOT_PASSWORD = '/forgot-password';
export const RESET_PASSWORD = '/set-password';
export const HOME = '/';
export const CHANGE_PASSWORD = '/change-password';
export const EDIT_PROFILE = '/edit-profile'

export const USER = "/dashboards/users";
export const USER_ADD = "/dashboards/add-users";
export const USER_EDIT = "/dashboards/update-users/:id";
export const createUserEditRoute = (id) => `/dashboards/update-users/${id}`;

export const CLIENT = "/client";
export const CLIENT_ADD = "/add-client";
export const CLIENT_EDIT = "/edit-client/:id";
export const createClientEditRoute = (id) => `/edit-client/${id}`;

export const PORTFOLIO = '/dashboards/portfolio';
export const PORTFOLIO_VIEW = '/dashboards/view-portfolio/:id';
export const createPortfolioViewRoute = id => `/dashboards/view-portfolio/${id}`;

export const TAX = '/tax';

export const SERVICE = '/service';

export const CASH_BOOK = "/cash-book";
export const CHEQUE_BOOK = "/cheque-book";
export const createCashChequeCreditDebitRoute = (id, type) =>`${id}?type=${type}`;
export const CASH_CREDIT_DEBIT = "/cash";
export const CASH ="/cash"
export const CHEQUE_CREDIT_DEBIT = "/cheque";
export const CHEQUE="/cheque"

export const REPORT = '/report';

export const INVOICE = '/invoice';
export const INVOICE_ADD = '/add-invoice'
export const INVOICE_EDIT = '/edit-invoice/:id';
export const createInvoiceEditRoute = id => `/edit-invoice/${id}`;
export const addInvoiceClientIdRoute = (id) => `/add-invoice?client-id=${id}`;

export const ROLE = '/dashboards/role';
export const ROLE_PERMISSION = '/dashboards/permission-role/:id';
export const createPermissionRoute = (id) => `/dashboards/permission-role/${id}`;

export const VENDOR = '/vendor';
export const VENDOR_ADD = '/add-vendor';
export const VENDOR_EDIT = '/edit-vendor/:id';
export const createVendorEditRoute = id => `/edit-vendor/${id}`;

export const EXPENSE = '/expense';
export const EXPENSE_ADD = '/add-expense';
export const EXPENSE_EDIT = '/edit-expense/:id';
export const createExpenseEditRoute = id => `/edit-expense/${id}`

export const BILL = '/bill';
export const BILL_ADD = '/add-bill'

export const BILL_EDIT = '/edit-bill/:id';
export const createBillEditRoute = id => `/edit-bill/${id}`;
export const addBillClientIdRoute = (id) => `/add-bill?vendor-id=${id}`;